// eslint-disable-next-line no-restricted-imports
import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Flags that are permanent and not subject to change.
 *
 * If you need are adding a temporary flag, add it to `useTemporaryFlags` instead.
 */
export type FeatureFlags = {
  deletionRecovery: boolean;
  libraries: boolean;
  hideShortUrlSignUpButton: string[];
  whiteLabelWorkspaces?: string[];
  enableSaml: boolean;
  apiAccess: boolean;
  showSharePointImportSource: boolean;
  forceReload: boolean;
  canSeeAddOns: boolean;
  maintenanceModeJson: {
    maintenanceMessage: string;
    bannerMessage: string;
  };
  sessionDuration: boolean;
  billingContact: boolean;
  fixedPricing: boolean;
  releaseVersion: string;
  disableUploadBoardConfirmation: boolean;
  versionsZipping: boolean;
  customFieldVisibility: boolean;
  invoices: boolean;
  videoTimestamp: boolean;
  canManagePeople: boolean;
  librariesCta: boolean;
  selectWorkspaceAuth: {
    domains?: string[];
  };
};

export const useFeatureFlags = () => useFlags<FeatureFlags>();
